export default [
  {
    path: '/login',
    name: 'login',
    meta: { title: '登录', auth: false },
    component: () => import('../../views/login/login-wechat.vue')
  },
  {
    path: '/login-phone',
    name: 'login-phone',
    meta: { title: '登录', auth: false },
    component: () => import('../../views/login/login-phone.vue')
  },
  {
    path: '/bind-phone',
    name: 'bind-phone',
    meta: { title: '绑定手机', auth: false },
    component: () => import('../../views/login/bind-phone.vue')
  },
  {
    path: '/agreement',
    name: 'agreement',
    meta: { title: '用户协议及隐私政策', auth: false },
    component: () => import('../../views/login/agreement.vue')
  },
  {
    path: '/base-info',
    name: 'base-info',
    meta: { title: '基础信息', auth: true },
    component: () => import('../../views/login/base-info.vue')
  },
  {
    path: '/perfect-info',
    name: 'perfect-info',
    meta: { title: '完善信息', auth: true },
    component: () => import('../../views/login/perfect-info.vue')
  },
  {
    path: '/examine',
    name: 'examine',
    meta: { title: '审核结果', auth: true },
    component: () => import('../../views/login/examine.vue')
  },
  {
    path: '/setHeader',
    name: 'examine',
    meta: { title: '设置Header', auth: false },
    component: () => import('../../views/login/setHeaders.vue')
  }
];
